<template>
  <div>
    <!-- CARD CREATE COMPONENT -->
    <!-- Analytic component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'analytic'"
      class="card-board m__b--60">
      <j-analytic-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Analytic2 component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'analytic_v2'"
      class="card-board m__b--60">
      <j-analytic2-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Attendance component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'attendance'"
      class="card-board m__b--60">
      <j-attendance-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Channel component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'channel'"
      class="card-board m__b--60">
      <j-channel-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Discussion component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'discussion'"
      class="card-board m__b--60">
      <j-discussion-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- HTML component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'html'"
      class="card-board m__b--60">
      <j-html-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Timesheet component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'timesheet'"
      class="card-board m__b--60">
      <j-timesheet-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Register Peruri component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'digital_signature_register_peruri'"
      class="card-board m__b--60">
      <j-register-peruri-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Sign document component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'digital_signature_sign'"
      class="card-board m__b--60">
      <j-sign-document-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Status document component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'digital_signature_document'"
      class="card-board m__b--60">
      <j-status-document-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Upload document component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'digital_signature_upload'"
      class="card-board m__b--60">
      <j-upload-document-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Create record component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'create_record'"
      class="card-board m__b--60">
      <j-create-record-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Todo task component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'todo_task'"
      class="card-board m__b--60">
      <j-todo-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Quota leave component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'quota_leave'"
      class="card-board m__b--60">
      <j-quota-leave-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Quota leave component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'leave_all_employee'"
      class="card-board m__b--60">
      <j-leave-all-employee-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Experience Manager component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'experience_manager'"
      class="card-board m__b--60">
      <j-experience-manager-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Embed Url component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'embed_url'"
      class="card-board m__b--60">
      <j-embed-url-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- QR Code Scanner component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'qrcode_scanner'"
      class="card-board m__b--60">
      <jQRCodeSetup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Shortcut Page component -->
    <b-card
      v-if="modeCreate && dataMaster.name === 'shortcut_page'"
      class="card-board m__b--60">
      <j-shortcut-page-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>
  </div>
</template>


<script>
/* eslint-disable max-len */
import jAnalyticSetup from '@/views/widget/widget-component/jAnalyticSetup';
import jAnalytic2Setup from '@/views/widget/widget-component/jAnalytic2Setup';
import jAttendanceSetup from '@/views/widget/widget-component/jAttendanceSetup';
import jChannelSetup from '@/views/widget/widget-component/jChannelSetup';
import jDiscussionSetup from '@/views/widget/widget-component/jDiscussionSetup';
import jHtmlSetup from '@/views/widget/widget-component/jHtmlSetup';
import jTimesheetSetup from '@/views/widget/widget-component/jTimesheetSetup';
import jRegisterPeruriSetup from '@/views/widget/widget-component/jRegisterPeruriSetup';
import jSignDocumentSetup from '@/views/widget/widget-component/jSignDocumentSetup';
import jStatusDocumentSetup from '@/views/widget/widget-component/jStatusDocumentSetup';
import jUploadDocumentSetup from '@/views/widget/widget-component/jUploadDocumentSetup';
import jCreateRecordSetup from '@/views/widget/widget-component/jCreateRecordSetup';
import jTodoSetup from '@/views/widget/widget-component/jTodoSetup';
import jQuotaLeaveSetup from '@/views/widget/widget-component/jQuotaLeaveSetup';
import jLeaveAllEmployeeSetup from '@/views/widget/widget-component/jLeaveAllEmployeeSetup';
import jExperienceManagerSetup from '@/views/widget/widget-component/jExperienceManagerSetup';
import jEmbedUrlSetup from '@/views/widget/widget-component/jEmbedUrlSetup';
import jQRCodeSetup from '@/views/widget/widget-component/jQRCodeSetup';
import jShortcutPageSetup from '@/views/widget/widget-component/jShortcutPageSetup';

export default {
  components: {
    jAnalyticSetup,
    jAnalytic2Setup,
    jAttendanceSetup,
    jChannelSetup,
    jDiscussionSetup,
    jHtmlSetup,
    jTimesheetSetup,
    jRegisterPeruriSetup,
    jSignDocumentSetup,
    jStatusDocumentSetup,
    jUploadDocumentSetup,
    jCreateRecordSetup,
    jTodoSetup,
    jQuotaLeaveSetup,
    jLeaveAllEmployeeSetup,
    jExperienceManagerSetup,
    jEmbedUrlSetup,
    jQRCodeSetup,
    jShortcutPageSetup,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataMaster: [Object, null],
    modeCreate: {
      type: Boolean,
      default: false,
      required: true,
    },
    modeEdit: {
      type: Boolean,
      default: false,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    dataEdit: [Object, null],
  },
  methods: {
    closeMode() {
      this.$emit('close-field');
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/views/widget/jWidgetComponentCreate.vue